/* curatedKinaseCases.js -- GENERATED, do not edit by hand.
 *
 * The curated kinase cases that have fragment data, partitioned by DFG
 * conformation. Each entry is a MapCase structureKey ("project/case"),
 * selectivity_-prefixed and matching the library's current dir names.
 *
 * Source of truth: tools/kinase-prep/curated-cases/*.txt (the prefixed
 * working lists; bare KLIFS originals under curated-cases/source-klifs/).
 * This module is a pure serialisation of those lists -- canonicalisation
 * is a data-prep step, not done here; see gen-curated-cases.py.
 * Regenerate with: python tools/kinase-prep/gen-curated-cases.py
 */

// DFG-in: 283 curated case(s) with fragment data.
export const DFG_IN_CASES = [
    'selectivity_AAK1/4WSQ_altA',
    'selectivity_ABL1/2GQG_altA',
    'selectivity_ABL2/2XYN_altA',
    'selectivity_ACK/4HZR_altA',
    'selectivity_ACTR2/3Q4T_altA',
    'selectivity_ACTR2B/2QLU',
    'selectivity_ADCK3/7UDP',
    'selectivity_AKT1/3CQU_altA',
    'selectivity_AKT2/3E87_altA',
    'selectivity_ALK/2YJR_altA',
    'selectivity_ALK1/3MY0',
    'selectivity_ALK2/3MTF_altA',
    'selectivity_AMPKa1/4RED',
    'selectivity_AMPKa2/4ZHX_altA',
    'selectivity_ANKRD3/5WNI',
    'selectivity_ATM/5NP0',
    'selectivity_ATR/5YZ0',
    'selectivity_AXL/5U6B',
    'selectivity_AurA/2X6D_altA',
    'selectivity_AurC/6GR8_altA',
    'selectivity_BARK1/3V5W_altA',
    'selectivity_BIKE/4W9W_altA',
    'selectivity_BMPR1B/3MDY_altA',
    'selectivity_BRAF/4H58_altA',
    'selectivity_BRK/5DA3_altA',
    'selectivity_BRSK2/4YNZ',
    'selectivity_BTK/3GEN_altA',
    'selectivity_BUB1/6F7B_altA',
    'selectivity_CASK/3C0G_altA',
    'selectivity_CDC2/4Y72_altA',
    'selectivity_CDC7/6YA7_altA',
    'selectivity_CDK2/1CKP_altA',
    'selectivity_CDK4/3G33',
    'selectivity_CDK5/4AU8_altA',
    'selectivity_CDK6/1BLX',
    'selectivity_CDK7/8P4Z_altA',
    'selectivity_CDK8/4F7S_altA',
    'selectivity_CDK9/4IMY_altA',
    'selectivity_CDKL1/4AGU',
    'selectivity_CDKL2/4AAA_altA',
    'selectivity_CDKL3/3ZDU',
    'selectivity_CDKL5/4BGQ_altA',
    'selectivity_CHED/7NXJ',
    'selectivity_CHK1/2BR1_altA',
    'selectivity_CHK2/2W7X_altA',
    'selectivity_CK1a/5FQD_C',
    'selectivity_CK1d/4KB8_altA',
    'selectivity_CK1e/4HOK',
    'selectivity_CK1g2/2C47_altA',
    'selectivity_CK1g3/2CHL_altA',
    'selectivity_CK2a1/3AT2_altA',
    'selectivity_CK2a2/5M4U_altA',
    'selectivity_CLK1/1Z57_altA',
    'selectivity_CLK2/6FYK_altA',
    'selectivity_CLK3/2EU9_altA',
    'selectivity_CLK4/6FYV_altA',
    'selectivity_COT/5IU2_altA',
    'selectivity_CRK7/8P81_altA',
    'selectivity_CSK/3D7T',
    'selectivity_CaMK1a/4FG7',
    'selectivity_CaMK1d/6QP5_altA',
    'selectivity_CaMK1g/2JAM_altA',
    'selectivity_CaMK2a/2VZ6_altA',
    'selectivity_CaMK2b/3BHH',
    'selectivity_CaMK2d/2WEL_altA',
    'selectivity_CaMK2g/2V7O_altA',
    'selectivity_CaMK4/2W4O',
    'selectivity_CaMKK2/5UYJ_altA',
    'selectivity_DAPK1/1JKS_altA',
    'selectivity_DAPK2/2A2A_altA',
    'selectivity_DAPK3/2J90_altA',
    'selectivity_DCAMKL1/6KYQ_altA',
    'selectivity_DLK/5CEN_altA',
    'selectivity_DMPK1/2VD5',
    'selectivity_DNAPK/7K0Y_altA',
    'selectivity_DRAK1/7QUE',
    'selectivity_DRAK2/3LM0_altA',
    'selectivity_DYRK1A/2VX3_altA',
    'selectivity_DYRK1B/8C2Z_altA',
    'selectivity_DYRK2/3KVW_altA',
    'selectivity_DYRK3/5Y86',
    'selectivity_EGFR/1M17_altA',
    'selectivity_EphA2/5I9U_altA',
    'selectivity_EphA3/2QO2_altA',
    'selectivity_EphA4/2Y6M_altA',
    'selectivity_EphA5/2R2P_altA',
    'selectivity_EphA7/2REI_altA',
    'selectivity_EphA8/3KUL_altA',
    'selectivity_EphB1/6UMW_altA',
    'selectivity_EphB2/1JPA',
    'selectivity_EphB4/2VWV_altA',
    'selectivity_ErbB2/3PP0_altA',
    'selectivity_ErbB3/6OP9_altA',
    'selectivity_ErbB4/2R4B_altA',
    'selectivity_Erk1/4QTB_altA',
    'selectivity_Erk2/4IZ7_altA',
    'selectivity_Erk3/7AQB_altA',
    'selectivity_Erk5/4ZSG_altA',
    'selectivity_FAK/2IJM_altA',
    'selectivity_FES/3BKB_altA',
    'selectivity_FGFR1/1AGW_altA',
    'selectivity_FGFR2/4J96_altA',
    'selectivity_FGFR3/6LVM',
    'selectivity_FGFR4/4TYG_altA',
    'selectivity_FGR/7UY0_altA',
    'selectivity_FMS/3LCD_altA',
    'selectivity_FRAP/4JSN',
    'selectivity_FYN/2DQ7_X',
    'selectivity_GAK/4C57_altA',
    'selectivity_GCN2/8T7T_altA',
    'selectivity_GPRK5/6PJX_altA',
    'selectivity_GPRK6/3NYN',
    'selectivity_GSK3A/7SXF_altA',
    'selectivity_GSK3B/1R0E_altA',
    'selectivity_HCK/2C0I_altA',
    'selectivity_HGK/4OBO_altA',
    'selectivity_HH498/4YFF_altA',
    'selectivity_HIPK2/6P5S_altA',
    'selectivity_HIPK3/7O7I',
    'selectivity_HPK1/6NFY_altA',
    'selectivity_Haspin/2WB8_altA',
    'selectivity_IGF1R/3D94_altA',
    'selectivity_IKKb/4KIK_altA',
    'selectivity_INSR/3EKK_altA',
    'selectivity_IRAK1/6BFN_altA',
    'selectivity_IRAK3/6RUU',
    'selectivity_IRAK4/2NRU_altA',
    'selectivity_IRE1/4YZC_altA',
    'selectivity_IRR/7TYK',
    'selectivity_ITK/3QGW_altA',
    'selectivity_JAK1/3EYG_altA',
    'selectivity_JAK1_b/4L00_altA',
    'selectivity_JAK2/2XA4_altA',
    'selectivity_JAK2_b/5I4N_altA',
    'selectivity_JAK3/1YVJ_altA',
    'selectivity_JNK1/3ELJ_altA',
    'selectivity_JNK2/7CML_altA',
    'selectivity_JNK3/2OK1_altA',
    'selectivity_KDR/3CJG_altA',
    'selectivity_KHS2/5J5T',
    'selectivity_KIT/8PQ9_altA',
    'selectivity_KSR2/2Y4I_B',
    'selectivity_LCK/3LCK_altA',
    'selectivity_LIMK1/3S95_altA',
    'selectivity_LIMK2/8WSW_altA',
    'selectivity_LOK/2J7T_altA',
    'selectivity_LRRK1/8FAC',
    'selectivity_LRRK2/8TZC',
    'selectivity_LYN/2ZV7',
    'selectivity_MAP2K1/3DV3_altA',
    'selectivity_MAP2K2/1S9I',
    'selectivity_MAP2K7/6YG1_altA',
    'selectivity_MAP3K5/3VW6_altA',
    'selectivity_MAPKAPK2/3KGA_altA',
    'selectivity_MAPKAPK3/3FHR_altA',
    'selectivity_MARK1/2HAK_B',
    'selectivity_MARK2/3IEC',
    'selectivity_MARK3/3FE3_altA',
    'selectivity_MARK4/5ES1',
    'selectivity_MASTL/5LOH_altA',
    'selectivity_MELK/4BKZ_altA',
    'selectivity_MER/3BPR_altA',
    'selectivity_MET/2WD1_altA',
    'selectivity_MLK1/4UY9_altA',
    'selectivity_MLKL/4M68_altA',
    'selectivity_MNK2/2AC5_altA',
    'selectivity_MPSK1/2BUJ',
    'selectivity_MRCKb/4UAK_altA',
    'selectivity_MSK1/1VZO_altA',
    'selectivity_MSK1_b/3KN6',
    'selectivity_MST1/8A5J_altA',
    'selectivity_MST2/4LG4_altA',
    'selectivity_MST3/4QMN_altA',
    'selectivity_MST4/7B36',
    'selectivity_MYT1/3P1A_altA',
    'selectivity_NEK2/2W5A_altA',
    'selectivity_NEK7/2WQM_altA',
    'selectivity_NIK/4G3C_altA',
    'selectivity_PAK1/4EQC_altA',
    'selectivity_PAK4/2CDZ_altA',
    'selectivity_PAK5/2F57_altA',
    'selectivity_PAK6/2C30_altA',
    'selectivity_PASK/3DLS',
    'selectivity_PBK/5J0A',
    'selectivity_PDGFRa/8PQI_altA',
    'selectivity_PDK1/1H1W_altA',
    'selectivity_PEK/4G34_altA',
    'selectivity_PHKg1/8XYB_C',
    'selectivity_PHKg2/2Y7J_altA',
    'selectivity_PI4K2A/4HNE',
    'selectivity_PI4KB/4D0L',
    'selectivity_PIK3C3/3LS8_altA',
    'selectivity_PIK3R4/8SOR_D',
    'selectivity_PIM1/1XWS_altA',
    'selectivity_PIM2/4X7Q',
    'selectivity_PKACa/3NX8_altA',
    'selectivity_PKCa/8U37_altA',
    'selectivity_PKCb/2I0E',
    'selectivity_PKCh/8FP3_altA',
    'selectivity_PKCi/4DC2_altA',
    'selectivity_PKCt/4Q9Z_altA',
    'selectivity_PKG1/6BDL_altA',
    'selectivity_PKN1/4OTG_altA',
    'selectivity_PKR/3UIU',
    'selectivity_PLK1/2OWB_altA',
    'selectivity_PLK2/4I5P_altA',
    'selectivity_PLK3/4B6L',
    'selectivity_PLK4/4JXF',
    'selectivity_PRP4/4IFC_altA',
    'selectivity_PRPK/7SZA_altA',
    'selectivity_PYK2/3CC6_altA',
    'selectivity_Pik3c2a/7BI2_altA',
    'selectivity_QSK/8OKU',
    'selectivity_RAF1/3OMV',
    'selectivity_RET/2IVS_altA',
    'selectivity_RIOK1/6ZXD_z',
    'selectivity_RIOK2/6FDN',
    'selectivity_RIPK2/5AR2_altA',
    'selectivity_RIPK3/4M66_altA',
    'selectivity_ROCK1/5WNF_altA',
    'selectivity_ROCK2/6P5M_altA',
    'selectivity_ROS/3ZBF',
    'selectivity_RSK1_b/8WF4',
    'selectivity_RSK2/4NW5_altA',
    'selectivity_RSK2_b/2QR7_altA',
    'selectivity_RSK1/2Z7Q',
    'selectivity_RSK1_b/2WNT_altA',
    'selectivity_RYK/6TUA',
    'selectivity_SGK1/3HDM',
    'selectivity_SLK/2UV2_altA',
    'selectivity_SMG1/6L53',
    'selectivity_SNRK/5YKS',
    'selectivity_SRC/2H8H_altA',
    'selectivity_SRPK1/4WUA_altA',
    'selectivity_SRPK2/5MYV_altA',
    'selectivity_STLK3/5D9H',
    'selectivity_STLK5/3GNI_B',
    'selectivity_SYK/1XBB_altA',
    'selectivity_SgK085/2X4F_altA',
    'selectivity_SgK269/6BHC_altA',
    'selectivity_SgK495/5L2Q_B_altA',
    'selectivity_TAK1/2EVA_altA',
    'selectivity_TAO3/6BDN_altA',
    'selectivity_TBK1/4EUT_altA',
    'selectivity_TGFbR1/2WOT_altA',
    'selectivity_TGFbR2/5E8V_altA',
    'selectivity_TIE2/3L8P',
    'selectivity_TNIK/2X7F_altA',
    'selectivity_TRKA/4AOJ_altA',
    'selectivity_TRKB/4AT3',
    'selectivity_TTBK1/4NFN_altA',
    'selectivity_TTBK2/6U0K_altA',
    'selectivity_TTK/3H9F_altA',
    'selectivity_TTN/4JNW_altA',
    'selectivity_TYK2/3NYX_altA',
    'selectivity_TYK2_b/4WOV_altA',
    'selectivity_TYRO3/4FEQ',
    'selectivity_Trb1/6DC0_altA',
    'selectivity_Trb2/7UPM',
    'selectivity_ULK1/4WNO_altA',
    'selectivity_ULK2/6QAU_altA',
    'selectivity_ULK3/6FDY_U',
    'selectivity_ULK4/6U5L_altA',
    'selectivity_VRK1/3OP5_altA',
    'selectivity_VRK2/2V62_altA',
    'selectivity_VRK3/2JII_altA',
    'selectivity_Wee1/3BI6_altA',
    'selectivity_Wee1B/5VDK',
    'selectivity_Wnk1/4PWN',
    'selectivity_Wnk3/5O1V_altA',
    'selectivity_YANK1/4FR4_altA',
    'selectivity_YSK1/2XIK_altA',
    'selectivity_ZAK/5HES_altA',
    'selectivity_ZAP70/1U59_altA',
    'selectivity_p110a/4JPS_altA',
    'selectivity_p110b/4BFR',
    'selectivity_p110d/2WXF_altA',
    'selectivity_p110g/3L08_altA',
    'selectivity_p38a/1OVE_altA',
    'selectivity_p38b/3GC8',
    'selectivity_p38d/3COI_altA',
    'selectivity_p38g/6UNA_altA',
    'selectivity_p70S6K/3WF5_altA',
];

// DFG-out: 94 curated case(s) with fragment data.
export const DFG_OUT_CASES = [
    'selectivity_ABL1/2HZ0_altA',
    'selectivity_ABL2/3GVU_altA',
    'selectivity_ACK/5ZXB_altA',
    'selectivity_AKT1/7NH5_altA',
    'selectivity_AKT2/8Q61_altA',
    'selectivity_ALK/5IUG_altA',
    'selectivity_AMPKa2/2H6D_altA',
    'selectivity_AurA/1MUO',
    'selectivity_BRAF/4XV9_altA',
    'selectivity_BRK/6CZ4_altA',
    'selectivity_CCK4/6VG3',
    'selectivity_CDK2/5A14_altA',
    'selectivity_CDK6/1BI7',
    'selectivity_CDK7/8BVW_I',
    'selectivity_CDK8/3RGF_altA',
    'selectivity_CK1e/4HNI',
    'selectivity_CaMK2a/7B55_altA',
    'selectivity_CaMKK1/6CD6_altA',
    'selectivity_DDR1/3ZOS_altA',
    'selectivity_DDR2/7AYM_altA',
    'selectivity_EGFR/4ZJV_altA',
    'selectivity_EphA2/5IA4_altA',
    'selectivity_EphA3/3DZQ_altA',
    'selectivity_EphA7/3DKO_altA',
    'selectivity_EphB4/6FNI_altA',
    'selectivity_ErbB3/7MN5',
    'selectivity_FAK/4EBW_altA',
    'selectivity_FGFR1/4V01_altA',
    'selectivity_FGFR4/4QRC',
    'selectivity_FGR/7UY3',
    'selectivity_FLT1/3HNG_altA',
    'selectivity_FLT3/4RT7_altA',
    'selectivity_FMS/3DPK_altA',
    'selectivity_GCN2/6N3L_altA',
    'selectivity_HGK/4OBO_B_altA',
    'selectivity_HH498/7MGK_altA',
    'selectivity_HPK1/8PAS',
    'selectivity_HSER/8FX4_D',
    'selectivity_IGF1R/3LW0_altA',
    'selectivity_INSR/3ETA_altA',
    'selectivity_IRAK4/6EG9_altA',
    'selectivity_IRE1/6HX1_altA',
    'selectivity_JAK2/3UGC_altA',
    'selectivity_JNK2/3NPC',
    'selectivity_KDR/2OH4_altA',
    'selectivity_KIT/1T45_altA',
    'selectivity_LCK/6PDJ_altA',
    'selectivity_LIMK1/7ATU',
    'selectivity_LIMK2/5NXD_altA',
    'selectivity_LKB1/8VSU_B',
    'selectivity_LMR3/6SEQ_altA',
    'selectivity_LOK/4EQU_altA',
    'selectivity_LRRK1/8E04',
    'selectivity_LRRK2/8TXZ_altA',
    'selectivity_MELK/5K00_altA',
    'selectivity_MER/7AAX_altA',
    'selectivity_MET/3CTJ_altA',
    'selectivity_MLKL/6O5Z_B',
    'selectivity_MNK1/2HW6',
    'selectivity_MNK2/2AC3',
    'selectivity_NEK2/2JAV_altA',
    'selectivity_NEK7/5DE2_altA',
    'selectivity_PAK1/4ZJI_altA',
    'selectivity_PCTAIRE1/5G6V',
    'selectivity_PDGFRa/5GRN_altA',
    'selectivity_PDK1/3QC4_altA',
    'selectivity_PEK/4X7H_altA',
    'selectivity_PHKg1/8JFL_B',
    'selectivity_PRP4/6CNH_altA',
    'selectivity_PYK2/3FZS',
    'selectivity_RAF1/8GAE_D',
    'selectivity_RIPK1/4ITH_altA',
    'selectivity_RIPK2/5AR7_altA',
    'selectivity_RIPK3/6OKO_altA',
    'selectivity_ROCK1/3TWJ_B',
    'selectivity_ROCK2/8GDS',
    'selectivity_ROR1/6TU9',
    'selectivity_ROR2/3ZZW_B_altA',
    'selectivity_SgK196/5GZ8',
    'selectivity_SLK/8BEM_altA',
    'selectivity_SRC/7OTE',
    'selectivity_SYK/3TUB',
    'selectivity_SgK223/5VE6',
    'selectivity_TAK1/2YIY',
    'selectivity_TIE2/6MWE_altA',
    'selectivity_TRKA/4GT5_altA',
    'selectivity_TRKB/4ASZ',
    'selectivity_TRKC/4YMJ_altA',
    'selectivity_TRRAP/8H7G',
    'selectivity_ULK3/6FDZ_U',
    'selectivity_p38a/2EWA_altA',
    'selectivity_p38b/3GP0_altA',
    'selectivity_p38d/4EYJ',
    'selectivity_p70S6K/3A60_B',
];

// DFG-out-like (not in the DFG-in or DFG-out lists): 34 curated case(s) with fragment data.
export const DFG_OUTLIKE_CASES = [
    'selectivity_ATM/6K9K',
    'selectivity_AurB/4AF3',
    'selectivity_BMX/3SXR',
    'selectivity_BTK/3OCT_altA',
    'selectivity_BUBR1/6TLJ_S',
    'selectivity_CDK4/5FWM_K',
    'selectivity_CSK/1BYG',
    'selectivity_CaMK1a/4FG8',
    'selectivity_EphB3/3ZFY_altA',
    'selectivity_Erk3/6YKY_altA',
    'selectivity_GAK/4C58_altA',
    'selectivity_HCK/3VS1',
    'selectivity_ILK/3KMW',
    'selectivity_IRAK3/6RUU_C',
    'selectivity_JNK3/3OXI',
    'selectivity_MAP2K4/3VUT',
    'selectivity_MAP2K6/3ENM_altA',
    'selectivity_MAP2K7/5B2L_altA',
    'selectivity_MAP3K5/2CLQ_altA',
    'selectivity_MARK1/2HAK',
    'selectivity_MST3/3CKW_altA',
    'selectivity_MST4/3GGF_altA',
    'selectivity_NEK1/4APC_altA',
    'selectivity_PI4K2B/8A5X',
    'selectivity_PIK3R4/7BL1_C',
    'selectivity_RSK2/3UBD_altA',
    'selectivity_STLK5/8VSU_C',
    'selectivity_SgK495/5L2Q_altA',
    'selectivity_TNIK/8X88',
    'selectivity_TYRO3/3QUP',
    'selectivity_Trb1/5CEM_altA',
    'selectivity_VRK1/2KTY_alt10',
    'selectivity_YSK1/4NZW_B',
    'selectivity_p110a/5SXE',
];
